<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>编辑代采组</div>
    </div>

    <el-row class="filter">
      <div
        style="
          width: 80%;
          margin: 0 auto;
          margin-top: 20px;
          margin-bottom: 20px;
        "
      >
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-width="120px"
          class="demo-ruleForm"
        >
          <el-form-item label="代采组id" prop="pgname">
            <el-input v-model="form.pgid" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="代采组" prop="pgname">
            <el-input v-model="form.pgname"></el-input>
          </el-form-item>
          <el-form-item label="代采组昵称" prop="pgnick">
            <el-input v-model="form.pgnick"></el-input>
          </el-form-item>
          <el-form-item label="代采组报单名" prop="pgbilling">
            <el-input v-model="form.pgbilling"></el-input>
          </el-form-item>
          <el-form-item label="城市：">
            <el-select
              v-model="form.city"
              placeholder="城市"
              @change="onCityChange"
            >
              <el-option value="0" label="全部"></el-option>
              <el-option
                v-for="item in citys"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="市场：">
            <el-card class="box-card" style="max-width: 1000px" shadow="never">
              <el-tabs
                v-model="activeTab"
                type="card"
                @tab-click="onMainMarketChange"
              >
                <el-tab-pane
                  v-for="item in marketList"
                  :key="item.key"
                  :label="item.label"
                  :name="item.key"
                >
                  <span slot="label">
                    {{ item.label }}
                    <span
                      v-if="
                        form.market_sub_id[`${item.key}`] &&
                        form.market_sub_id[`${item.key}`].length > 0
                      "
                      style="color: #fc1"
                    >
                      （已选{{ form.market_sub_id[`${item.key}`].length }}个）
                    </span>
                  </span>
                </el-tab-pane>
              </el-tabs>
              <el-checkbox-group v-model="form.market_sub_id[activeTab]">
                <el-checkbox
                  v-for="v in subMarketList"
                  :key="v.key"
                  :label="v.key"
                >
                  {{ v.label }}
                </el-checkbox>
              </el-checkbox-group>
            </el-card>
          </el-form-item>
          <el-form-item label="是否启用" prop="is_use">
            <el-select v-model="form.is_use" filterable placeholder="是否启用">
              <el-option
                v-for="item in is_use"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
    <el-row></el-row>
  </div>
</template>

<script>
import { CITY } from "@/const/CommonConst.js";
import { postGetChildMarket, postGetMainMarket } from "@/openapi/erp/supply.js";
import { removeFalsy } from "@/utils/utils.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      marketList: [], // 主市场列表
      subMarketList: [], // 子市场列表
      resData: null,
      form: {
        pgname: "",
        pgnick: "",
        pgbilling: "",
        city: "",
        market_sub_id: {},
        supply_grade: [],
      },
      citys: CITY,
      is_use: [
        {
          value: "1",
          label: "启用",
        },
        {
          value: "0",
          label: "禁用",
        },
      ],
      rules: {
        pgname: [
          {
            required: true,
            message: "请输入代采组名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 20,
            message: "档口号最长可以输入20个字符",
            trigger: "blur",
          },
        ],
        pgnick: [
          {
            required: true,
            message: "请输入代采组昵称",
            trigger: "blur",
          },
        ],
        city: [{ required: true, message: "请选择城市", trigger: "change" }],
      },
      loading: false,
      tableLoading: false,
      url: "/erp/PurchaseGroup/detail/pgid/",
      activeTab: "",
    };
  },
  computed: {
    filteredForm() {
      Object.keys(this.form).forEach((key) => {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      });
      console.log("this.form", this.form);
      return this.form;
    },
  },
  methods: {
    onCityChange() {
      this.subMarketList = [];
      this.form.market_id = "";
      this.form.market_sub_id = {};
      this.getMainMarketByCity();
    },
    getMainMarketByCity() {
      postGetMainMarket({ city: this.form.city }).then((res) => {
        // 初始化市场
        this.activeTab = res[0].key;
        this.marketList = res;
        this.getSubMarketList();
      });
    },
    onMainMarketChange() {
      this.getSubMarketList();
    },
    getSubMarketList() {
      postGetChildMarket({ parent_id: this.activeTab }).then((res) => {
        const { market_sub_id: marketSubIds } = this.form;
        if (!marketSubIds[this.activeTab]) {
          this.$set(this.form.market_sub_id, this.activeTab, []);
        }
        this.subMarketList = res;
      });
    },
    fetchData(showLoading) {
      if (this.$route.params.id) {
        if (showLoading) {
          this.loading = true;
        }
        this.$http
          .get(this.url + this.$route.params.id, removeFalsy(this.form))
          .then((res) => {
            this.loading = false;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              const { data } = res.data;
              this.resData = data;
              // 整理市场子节点
              const marketObject = data.market_child.reduce((acc, market) => {
                acc[market.market_id] = market.sub_market_id;
                return acc;
              }, {});
              this.form = { ...data, market_sub_id: marketObject };
              this.getMainMarketByCity();
            }
          });
      }
    },
    onSubmit() {
      if (this.form.is_use === "0") {
        this.$confirm(
          "新建商家是不能再绑定已禁用的代采组,确定禁用代采组?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          this.postHandle();
        });
      } else {
        this.postHandle();
      }
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    postHandle() {
      this.loading = true;
      const url = "/erp/PurchaseGroup/savePgInfo";
      const { market_sub_id: marketSubId, ...rest } = this.filteredForm;
      const marketSub = Object.values(marketSubId).flat();
      const params = { ...rest, market_sub_id: marketSub };
      this.$http.post(url, params).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$message({
            type: 1,
            message: res.data.msg,
          });
          this.form = {};
          this.$router.push(
            `/home/purchase?type=group&time=${Date.parse(new Date())}`
          );
        }
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/purchasegroup/UpdatePGroup.vue